<template>
	<div class="around-collapsible" :style="selectedBorderCollapsible">
		<div class="button collapsible" :style="selectedCollapsible" :class="(selected && product !== 'general') ? 'is-white-card' : 'is-card-color'" @click="selection(product)">
			<div class="is-padded-left is-flex-grow-2 has-text-left text-ellipse">
				<template v-if="product !== 'general'">
				<span class="icon is-vertical-align">
					<i class="monizze-icon" :class="'monizze-icon-product-' + product + (selected ? '-negative' : '')"></i>
				</span>
				</template>
				<span :style="{'padding-left' : product !== 'general' ? '5px' : '0px'}">{{name}}</span>
			</div>
			<span class="icon mr-3 mt-2">
				<i class="fa-solid" :class="selected ? 'fa-angle-down' : 'fa-angle-right'"></i>
			</span>
		</div>
		<div class="collapsible-content is-padded-left" v-if="selected">
			<div class="is-multiline is-mobile">
				<table class="table is-padded-left is-fullwidth">
					<tbody v-if="product === 'general'">
						<tr>
							<td class="has-text-left"><b>{{translation.oneTimeFees.title}}</b></td>
						</tr>
						<tr>
							<td class="has-text-left has-tiny-text">
								<span class="text-ellipse">
									&nbsp;&nbsp;{{translation.setup}}
									<br />
									&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{translation.per_card.setup}}</span>
								</span>
							</td>
							<td class="has-text-right" :class="pricing.setup === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(pricing.setup)}}</td>
						</tr>

						<tr>
							<td class="has-text-left"><b class="is-block is-half-marged-top">{{translation.recurentFees.title}}</b></td>
						</tr>
						<tr>
							<td class="has-text-left has-tiny-text">
								<span class="text-ellipse">
									&nbsp;&nbsp;{{ translation.sms }}
									<br />
									&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{translation.per_card.sms}}</span>
								</span>
							</td>
							<td class="has-text-right" :class="pricing.SMSNotification === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(pricing.SMSNotification)}}</td>
						</tr>

						<tr>
							<td class="has-text-left"><b class="is-block is-half-marged-top">{{translation.card.title}}</b></td>
						</tr>
						<template v-for="(price,key) in pricing.card">
							<tr>
								<td class="has-text-left has-tiny-text">
									<span class="text-ellipse">
										&nbsp;&nbsp;{{translation.card[key]}} <b v-if="key === 'default'">²</b>
										<br />
										&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{translation.per_card[key]}}</span>
									</span>
								</td>
								<td class="has-text-right" :class="price === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(price)}}</td>
							</tr>
						</template>
					</tbody>
					<tbody v-else>
						<tr>
							<td class="has-text-left">{{ translation.beneficiaries }}</td>
							<td class="has-text-right">{{ pricing.beneficiaries }}</td>
						</tr>

						<tr>
							<td class="has-text-left"><b>{{ translation.oneTimeFees.title }}</b></td>
						</tr>
						<tr>
							<td class="has-text-left has-tiny-text">
								<span class="text-ellipse">
									&nbsp;&nbsp;{{translation.oneTimeFees.account}}
									<br />
									&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{ translation.per_card.account }}</span>
								</span>
							</td>
							<td class="has-text-right" :class="pricing.walletActivation === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(pricing.walletActivation)}}</td>
						</tr>

						<tr>
							<td class="has-text-left"><b>{{translation.recurentFees.title}}</b></td>
						</tr>
						<tr>
							<td class="has-text-left has-tiny-text">
								<span class="text-ellipse">
									&nbsp;&nbsp;{{translation.recurentFees.orderFee}}
									<br />
									&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{ translation.per_card.orderFee}}</span>
								</span>
							</td>
							<td class="has-text-right" :class="pricing.load === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(pricing.load)}}</td>
						</tr>
						<tr>
							<td class="has-text-left has-tiny-text">
								<span class="text-ellipse">
									&nbsp;&nbsp;{{translation.recurentFees.licence}} <b>¹</b>
									<br />
									&nbsp;&nbsp;<span class="is-size-7 has-text-grey-darker">{{ translation.per_card.license }}</span>
								</span>
							</td>
							<td class="has-text-right" :class="pricing.yearlyLicence === 0 ? 'has-text-weight-bold' : ''">{{priceBuild(pricing.yearlyLicence)}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			pricing: {
				type: Object,
				required: true,
				default : {
					yearlyLicence: 0,
					walletActivation: 0,
					beneficiaries: 0,
					load: 0,
					setup: 0,
					SMSNotification: 0,
					card: {
						logo: 0,
						promo: 0,
						default: 0,
						blocked: 0,
						renewal: 0
					}
				}
			},
			product : {
				type : String,
				required : false,
				default : 'general'
			},
			name : {
				type : String,
				required : false,
				default : 'Generic pricing'
			},
			selection: {
				type : Function,
				required : true,
			},
			selected : {
				type : Boolean,
				require : true,
				default : 1
			},
			colorSelected : {
				type : String,
				required : false,
				default : '#f4f4f4'
			},
			translation : {
				type : Object,
				required : true
			}
		},
		methods: {
			priceBuild : function (price)
			{
				var formatter = new Intl.NumberFormat('be-FR', {
					style: 'currency',
					currency: 'EUR'
				});
				if(price === 0 )
				{
					return this.translation.free;
				}
				return formatter.format(price/100);
			},
		},
		computed: {
			selectedCollapsible : function ()
			{
				var style = {
					'border-radius' : '8px',
					'font-size' : '17px'
				};

				if (this.selected)
				{
					style['border-bottom-left-radius'] = '0px';
					style['border-bottom-right-radius'] = '0px';
				}
				style['background-color'] = this.selected ? this.colorSelected : 'white'
				return style;
			},
			selectedBorderCollapsible : function()
			{
				return {
					'border-color': this.selected ? this.colorSelected : '#E2E4E4',
				};
			}
		}

	}
</script>

<style scoped lang="sass">
	.is-white-card
		color: white
	.button
		border : none
		height : 48px

	.table th, .table td
		padding-top: 0.2rem
		padding-bottom: 0.3rem
	table
		margin-top: 16px
		margin-bottom: 16px
		border: none
	@media (min-width: 1024px) and (max-width: 1300px)
		.around-collapsible .has-text-left:not(.is-flex-grow-2)
			display: block
			padding: 0
		.around-collapsible .has-text-right
			display: block
			width: 160px
			text-align: left !important
			padding-left: 8px
			margin-bottom: 5px
</style>
